import { IReportsDetailsByPID } from "@redux/reducers/reportsReducer";

export enum ActionType {
  REPORTS_DETAILS_BY_PID = "REPORTS_DETAILS_BY_PID",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}

export interface IReportsDetailsByPid {
  type: ActionType.REPORTS_DETAILS_BY_PID;
  payload: IReportsDetailsByPID[];
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = IReportsDetailsByPid | IResetReduxState;
